const subCategoryList = [
    {
        "value": 1,
        "name": "لپتاپ و تبلت",
        "description": "",
        "label": "دیجیتال و الکترونیکی / لپتاپ و تبلت",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 2,
        "name": "اسپیکر بلوتوثی",
        "description": "",
        "label": "دیجیتال و الکترونیکی / اسپیکر بلوتوثی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 3,
        "name": "ویدئو پروژکتور ",
        "description": "",
        "label": "دیجیتال و الکترونیکی / ویدئو پروژکتور ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 4,
        "name": "پرینتر ",
        "description": "",
        "label": "دیجیتال و الکترونیکی / پرینتر ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 5,
        "name": " اسکنر",
        "description": "",
        "label": "دیجیتال و الکترونیکی /  اسکنر",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 6,
        "name": "تبلت",
        "description": "",
        "label": "دیجیتال و الکترونیکی / تبلت",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 7,
        "name": "لپ تاپ",
        "description": "",
        "label": "دیجیتال و الکترونیکی / لپ تاپ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 9,
        "name": "دوربین عکاسی DSLR",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / دوربین عکاسی DSLR",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 10,
        "name": "دوربین بدون آینه (Mirrorless)",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / دوربین بدون آینه (Mirrorless)",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 11,
        "name": "دوربین فیلمبرداری",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / دوربین فیلمبرداری",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 12,
        "name": "دوربین ورزشی (اکشن کمرا)",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / دوربین ورزشی (اکشن کمرا)",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 13,
        "name": "دوربین ۳۶۰ درجه",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / دوربین ۳۶۰ درجه",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 14,
        "name": "پایه دوربین ",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / پایه دوربین ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 15,
        "name": "لنز دوربین",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / لنز دوربین",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 16,
        "name": "فلاش اکسترنال",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / فلاش اکسترنال",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 17,
        "name": "نور ثابت و رینگ لایت",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / نور ثابت و رینگ لایت",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 18,
        "name": "باتری و شارژر دوربین",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / باتری و شارژر دوربین",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 19,
        "name": "کارت حافظه ",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / کارت حافظه ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 20,
        "name": "کوله و کیف دوربین",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / کوله و کیف دوربین",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 21,
        "name": "پرده کروماکی",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / پرده کروماکی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 22,
        "name": "اسلایدر و استابلایزر",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / اسلایدر و استابلایزر",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 23,
        "name": "رکوردر صدا و تصویر",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / رکوردر صدا و تصویر",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 24,
        "name": "هولدر موبایل برای فیلمبرداری",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / هولدر موبایل برای فیلمبرداری",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 25,
        "name": "پهپاد فیلمبرداری (Drone)",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / پهپاد فیلمبرداری (Drone)",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 26,
        "name": " LED پنل",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری /  LED پنل",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 27,
        "name": "سافت باکس",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / سافت باکس",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 28,
        "name": "فیلتر لنز",
        "description": "",
        "label": "تجهیزات عکاسی و فیلمبرداری / فیلتر لنز",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 30,
        "name": "میکروفون یقه ای",
        "description": "",
        "label": "تجهیزات صوت و تصویر / میکروفون یقه ای",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 31,
        "name": "میکروفون استودیویی",
        "description": "",
        "label": "تجهیزات صوت و تصویر / میکروفون استودیویی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 32,
        "name": "میکروفون بی سیم",
        "description": "",
        "label": "تجهیزات صوت و تصویر / میکروفون بی سیم",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 33,
        "name": "اسپیکر بلوتوثی",
        "description": "",
        "label": "تجهیزات صوت و تصویر / اسپیکر بلوتوثی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 34,
        "name": "اسپیکر حرفه ای و مانیتورینگ",
        "description": "",
        "label": "تجهیزات صوت و تصویر / اسپیکر حرفه ای و مانیتورینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 35,
        "name": "هدفون استودیویی",
        "description": "",
        "label": "تجهیزات صوت و تصویر / هدفون استودیویی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 36,
        "name": "میکسر صدا",
        "description": "",
        "label": "تجهیزات صوت و تصویر / میکسر صدا",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 37,
        "name": "آمپلی فایر",
        "description": "",
        "label": "تجهیزات صوت و تصویر / آمپلی فایر",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 38,
        "name": "سیستم های کنفرانس صوتی",
        "description": "",
        "label": "تجهیزات صوت و تصویر / سیستم های کنفرانس صوتی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 39,
        "name": "ویدئو پروژکتور",
        "description": "",
        "label": "تجهیزات صوت و تصویر / ویدئو پروژکتور",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 40,
        "name": "پرده نمایش",
        "description": "",
        "label": "تجهیزات صوت و تصویر / پرده نمایش",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 41,
        "name": "نمایشگر و تلویزیون حرفه ای",
        "description": "",
        "label": "تجهیزات صوت و تصویر / نمایشگر و تلویزیون حرفه ای",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 42,
        "name": "ساندبار",
        "description": "",
        "label": "تجهیزات صوت و تصویر / ساندبار",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 43,
        "name": "کارت صدا",
        "description": "",
        "label": "تجهیزات صوت و تصویر / کارت صدا",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 44,
        "name": "رکوردر صوتی",
        "description": "",
        "label": "تجهیزات صوت و تصویر / رکوردر صوتی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 45,
        "name": "اکولایزر",
        "description": "",
        "label": "تجهیزات صوت و تصویر / اکولایزر",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 46,
        "name": "دستگاه ترجمه همزمان",
        "description": "",
        "label": "تجهیزات صوت و تصویر / دستگاه ترجمه همزمان",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 47,
        "name": "تجهیزات آکوستیک و عایق صدا",
        "description": "",
        "label": "تجهیزات صوت و تصویر / تجهیزات آکوستیک و عایق صدا",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 48,
        "name": "دستگاههای استریمینگ",
        "description": "",
        "label": "تجهیزات صوت و تصویر / دستگاههای استریمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 49,
        "name": "چراغ های LED",
        "description": "",
        "label": "تجهیزات صوت و تصویر / چراغ های LED",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 50,
        "name": "نورافکن",
        "description": "",
        "label": "تجهیزات صوت و تصویر / نورافکن",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 51,
        "name": "سیستم های نورپردازی هوشمند",
        "description": "",
        "label": "تجهیزات صوت و تصویر / سیستم های نورپردازی هوشمند",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 52,
        "name": "کابل های صوتی و تصویری",
        "description": "",
        "label": "تجهیزات صوت و تصویر / کابل های صوتی و تصویری",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 54,
        "name": "کنسول بازی ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / کنسول بازی ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 55,
        "name": "کنترلر و دسته بازی",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / کنترلر و دسته بازی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 56,
        "name": "کیبورد و ماوس گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / کیبورد و ماوس گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 57,
        "name": "مانیتور گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / مانیتور گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 58,
        "name": "هدست گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / هدست گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 59,
        "name": "صندلی گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / صندلی گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 60,
        "name": "دسته بازی موبایل",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / دسته بازی موبایل",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 61,
        "name": "استند و داک کنسول",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / استند و داک کنسول",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 62,
        "name": "خنک کننده کنسول",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / خنک کننده کنسول",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 63,
        "name": "کارت گرافیک گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / کارت گرافیک گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 64,
        "name": "پردازنده مخصوص بازی",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / پردازنده مخصوص بازی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 65,
        "name": "میز گیمینگ",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / میز گیمینگ",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 66,
        "name": "نورپردازی RGB",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / نورپردازی RGB",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 67,
        "name": "واقعیت مجازی (VR) مخصوص بازی",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / واقعیت مجازی (VR) مخصوص بازی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 68,
        "name": "فرمان و پدال شبیه ساز رانندگی",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / فرمان و پدال شبیه ساز رانندگی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 69,
        "name": "کارت کپچر و استریم",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / کارت کپچر و استریم",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 70,
        "name": "میکروفون مخصوص استریم",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / میکروفون مخصوص استریم",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 71,
        "name": "سنسورهای حرکتی",
        "description": "",
        "label": "تجهیزات گیمینگ (بازی) / سنسورهای حرکتی",
        "productCategoryId": 1,
        "productCategoryName": "دیجیتال و الکترونیکی"
    },
    {
        "value": 73,
        "name": "تجهیزات بدنسازی",
        "description": "",
        "label": "تجهیزات ورزشی / تجهیزات بدنسازی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 74,
        "name": "طناب ورزشی",
        "description": "",
        "label": "تجهیزات ورزشی / طناب ورزشی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 75,
        "name": "دوچرخه",
        "description": "",
        "label": "تجهیزات ورزشی / دوچرخه",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 76,
        "name": "ترامپولین",
        "description": "",
        "label": "تجهیزات ورزشی / ترامپولین",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 77,
        "name": "میز و راکت پینگ پنگ  ",
        "description": "",
        "label": "تجهیزات ورزشی / میز و راکت پینگ پنگ  ",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 78,
        "name": "تجهیزات کوهنوردی",
        "description": "",
        "label": "تجهیزات ورزشی / تجهیزات کوهنوردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 79,
        "name": "انواع توپ ورزشی ",
        "description": "",
        "label": "تجهیزات ورزشی / انواع توپ ورزشی ",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 80,
        "name": "لباس و کفش ورزشی",
        "description": "",
        "label": "تجهیزات ورزشی / لباس و کفش ورزشی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 81,
        "name": "اسکیت و اسکوتر",
        "description": "",
        "label": "تجهیزات ورزشی / اسکیت و اسکوتر",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 82,
        "name": "میز فوتبال دستی",
        "description": "",
        "label": "تجهیزات ورزشی / میز فوتبال دستی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 83,
        "name": "لباس و تجهیزات موتور سواری",
        "description": "",
        "label": "تجهیزات ورزشی / لباس و تجهیزات موتور سواری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 84,
        "name": "کیسه بوکس",
        "description": "",
        "label": "تجهیزات ورزشی / کیسه بوکس",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 85,
        "name": " لباس و تجهیزات غواصی",
        "description": "",
        "label": "تجهیزات ورزشی /  لباس و تجهیزات غواصی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 86,
        "name": "تخته موج سواری",
        "description": "",
        "label": "تجهیزات ورزشی / تخته موج سواری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 87,
        "name": "تجهیزات ماهیگیری",
        "description": "",
        "label": "تجهیزات ورزشی / تجهیزات ماهیگیری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 88,
        "name": "لباس و تجهیزات اسکی",
        "description": "",
        "label": "تجهیزات ورزشی / لباس و تجهیزات اسکی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 89,
        "name": "تخته اسنوبورد",
        "description": "",
        "label": "تجهیزات ورزشی / تخته اسنوبورد",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 90,
        "name": "تجهیزات شنا",
        "description": "",
        "label": "تجهیزات ورزشی / تجهیزات شنا",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 91,
        "name": "چتر نجات",
        "description": "",
        "label": "تجهیزات ورزشی / چتر نجات",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 92,
        "name": "تجهیزات تیراندازی ",
        "description": "",
        "label": "تجهیزات ورزشی / تجهیزات تیراندازی ",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 94,
        "name": "چادر مسافرتی",
        "description": "",
        "label": "سفر و کمپینگ / چادر مسافرتی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 95,
        "name": "کیسه خواب",
        "description": "",
        "label": "سفر و کمپینگ / کیسه خواب",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 96,
        "name": "زیرانداز",
        "description": "",
        "label": "سفر و کمپینگ / زیرانداز",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 97,
        "name": "کوله پشتی کوهنوردی",
        "description": "",
        "label": "سفر و کمپینگ / کوله پشتی کوهنوردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 98,
        "name": "چراغ قوه و هدلایت",
        "description": "",
        "label": "سفر و کمپینگ / چراغ قوه و هدلایت",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 99,
        "name": "اجاق سفری",
        "description": "",
        "label": "سفر و کمپینگ / اجاق سفری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 100,
        "name": "منقل و باربیکیو",
        "description": "",
        "label": "سفر و کمپینگ / منقل و باربیکیو",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 101,
        "name": "قمقمه و فلاسک",
        "description": "",
        "label": "سفر و کمپینگ / قمقمه و فلاسک",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 102,
        "name": "ظرف و ظروف سفری",
        "description": "",
        "label": "سفر و کمپینگ / ظرف و ظروف سفری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 103,
        "name": "چاقو و ابزار چندکاره",
        "description": "",
        "label": "سفر و کمپینگ / چاقو و ابزار چندکاره",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 104,
        "name": "صندلی و میز تاشو",
        "description": "",
        "label": "سفر و کمپینگ / صندلی و میز تاشو",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 105,
        "name": "پتوی مسافرتی",
        "description": "",
        "label": "سفر و کمپینگ / پتوی مسافرتی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 106,
        "name": "پاوربانک خورشیدی",
        "description": "",
        "label": "سفر و کمپینگ / پاوربانک خورشیدی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 107,
        "name": "گاز سفری",
        "description": "",
        "label": "سفر و کمپینگ / گاز سفری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 108,
        "name": "کلمن آب",
        "description": "",
        "label": "سفر و کمپینگ / کلمن آب",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 109,
        "name": "دوش سفری",
        "description": "",
        "label": "سفر و کمپینگ / دوش سفری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 110,
        "name": "قطب نما",
        "description": "",
        "label": "سفر و کمپینگ / قطب نما",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 111,
        "name": "عینک آفتابی",
        "description": "",
        "label": "سفر و کمپینگ / عینک آفتابی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 112,
        "name": "کلاه آفتاب گیر",
        "description": "",
        "label": "سفر و کمپینگ / کلاه آفتاب گیر",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 113,
        "name": "کرم ضدآفتاب",
        "description": "",
        "label": "سفر و کمپینگ / کرم ضدآفتاب",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 114,
        "name": "دوربین دوچشمی",
        "description": "",
        "label": "سفر و کمپینگ / دوربین دوچشمی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 115,
        "name": "دستگاه تصفیه آب سفری",
        "description": "",
        "label": "سفر و کمپینگ / دستگاه تصفیه آب سفری",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 116,
        "name": "طناب و کارابین",
        "description": "",
        "label": "سفر و کمپینگ / طناب و کارابین",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 117,
        "name": "اسپری ضدحشرات",
        "description": "",
        "label": "سفر و کمپینگ / اسپری ضدحشرات",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 118,
        "name": "واکی تاکی",
        "description": "",
        "label": "سفر و کمپینگ / واکی تاکی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 119,
        "name": "نردبان کوهنوردی",
        "description": "",
        "label": "سفر و کمپینگ / نردبان کوهنوردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 120,
        "name": "کفش کوهنوردی",
        "description": "",
        "label": "سفر و کمپینگ / کفش کوهنوردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 121,
        "name": "لباس مخصوص طبیعت گردی",
        "description": "",
        "label": "سفر و کمپینگ / لباس مخصوص طبیعت گردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 122,
        "name": "باتوم کوهنوردی",
        "description": "",
        "label": "سفر و کمپینگ / باتوم کوهنوردی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 123,
        "name": "کیت کمک های اولیه",
        "description": "",
        "label": "سفر و کمپینگ / کیت کمک های اولیه",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 124,
        "name": "دستکش مخصوص کمپینگ",
        "description": "",
        "label": "سفر و کمپینگ / دستکش مخصوص کمپینگ",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 125,
        "name": "سایبان",
        "description": "",
        "label": "سفر و کمپینگ / سایبان",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 126,
        "name": "دوربین دوچشمی",
        "description": "",
        "label": "سفر و کمپینگ / دوربین دوچشمی",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 127,
        "name": "قطب نما و GPS",
        "description": "",
        "label": "سفر و کمپینگ / قطب نما و GPS",
        "productCategoryId": 2,
        "productCategoryName": "ورزشی و تفریحی"
    },
    {
        "value": 129,
        "name": "دریل ",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / دریل ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 130,
        "name": "پیچ گوشتی شارژی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / پیچ گوشتی شارژی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 131,
        "name": "ابزارآلات سبک (انواع آچار و پیچ گوشتی)",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / ابزارآلات سبک (انواع آچار و پیچ گوشتی)",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 132,
        "name": "تراز دستی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / تراز دستی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 133,
        "name": "چسب حرارتی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / چسب حرارتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 134,
        "name": "سشوار صنعتی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / سشوار صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 135,
        "name": "اره عمودبر",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / اره عمودبر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 136,
        "name": "پیچ گوشتی ستاره ای",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / پیچ گوشتی ستاره ای",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 137,
        "name": "ابزارآلات ساختمانی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / ابزارآلات ساختمانی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 138,
        "name": "بالابر ساختمانی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / بالابر ساختمانی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 139,
        "name": "مته بتن کن",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / مته بتن کن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 140,
        "name": "تراز",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / تراز",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 141,
        "name": "دژبر",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / دژبر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 142,
        "name": "تخته داربست",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / تخته داربست",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 143,
        "name": "کمپرسور بادی",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / کمپرسور بادی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 144,
        "name": "میکسر بتن",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / میکسر بتن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 145,
        "name": "دستگاه برش سنگ و سرامیک",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / دستگاه برش سنگ و سرامیک",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 146,
        "name": "چکش تخریب",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / چکش تخریب",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 147,
        "name": "دستگاه جوش",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / دستگاه جوش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 148,
        "name": "دستگاه شیارزن",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / دستگاه شیارزن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 149,
        "name": "قیچی میلگردبر",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / قیچی میلگردبر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 150,
        "name": "قالب بندی بتن",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / قالب بندی بتن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 151,
        "name": "ابزار دیوار چینی (ماله، کمچه، شاقول و...)",
        "description": "",
        "label": "ابزارآلات عمومی و خانگی / ابزار دیوار چینی (ماله، کمچه، شاقول و...)",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 153,
        "name": "دریل صنعتی",
        "description": "",
        "label": "ابزارآلات صنعتی / دریل صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 154,
        "name": "فرز سنگ بری",
        "description": "",
        "label": "ابزارآلات صنعتی / فرز سنگ بری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 155,
        "name": "مینی فرز",
        "description": "",
        "label": "ابزارآلات صنعتی / مینی فرز",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 156,
        "name": "کمپرسور باد",
        "description": "",
        "label": "ابزارآلات صنعتی / کمپرسور باد",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 157,
        "name": "دستگاه تراش",
        "description": "",
        "label": "ابزارآلات صنعتی / دستگاه تراش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 158,
        "name": "سنگ رومیزی",
        "description": "",
        "label": "ابزارآلات صنعتی / سنگ رومیزی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 159,
        "name": "پرس هیدرولیک",
        "description": "",
        "label": "ابزارآلات صنعتی / پرس هیدرولیک",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 160,
        "name": "اینورتر جوشکاری",
        "description": "",
        "label": "ابزارآلات صنعتی / اینورتر جوشکاری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 161,
        "name": "اره نواری",
        "description": "",
        "label": "ابزارآلات صنعتی / اره نواری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 162,
        "name": "ابزارهای بادی و پنوماتیک",
        "description": "",
        "label": "ابزارآلات صنعتی / ابزارهای بادی و پنوماتیک",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 163,
        "name": "دستگاه CNC",
        "description": "",
        "label": "ابزارآلات صنعتی / دستگاه CNC",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 164,
        "name": "دستگاه حکاکی و برش لیزر",
        "description": "",
        "label": "ابزارآلات صنعتی / دستگاه حکاکی و برش لیزر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 165,
        "name": "قیچی برش صنعتی",
        "description": "",
        "label": "ابزارآلات صنعتی / قیچی برش صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 166,
        "name": "لیفتراک",
        "description": "",
        "label": "ابزارآلات صنعتی / لیفتراک",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 167,
        "name": "جک پالت",
        "description": "",
        "label": "ابزارآلات صنعتی / جک پالت",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 168,
        "name": "جرثقیل دستی",
        "description": "",
        "label": "ابزارآلات صنعتی / جرثقیل دستی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 169,
        "name": "گیج فشار",
        "description": "",
        "label": "ابزارآلات صنعتی / گیج فشار",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 170,
        "name": "دماسنج صنعتی",
        "description": "",
        "label": "ابزارآلات صنعتی / دماسنج صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 172,
        "name": "جک خودرو",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / جک خودرو",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 173,
        "name": "آچار بکس",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / آچار بکس",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 174,
        "name": "کمپرسور باد",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / کمپرسور باد",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 175,
        "name": "ساکشن روغن",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / ساکشن روغن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 176,
        "name": "انژکتور شور",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / انژکتور شور",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 177,
        "name": "مولتی متر خودرو",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / مولتی متر خودرو",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 178,
        "name": "لوازم پنچرگیری",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / لوازم پنچرگیری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 179,
        "name": "پولی کش",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / پولی کش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 180,
        "name": "دستگاه دیاگ",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / دستگاه دیاگ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 181,
        "name": "سشوار صنعتی",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / سشوار صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 182,
        "name": "ترکمتر",
        "description": "",
        "label": "ابزارآلات مکانیکی و خودرویی / ترکمتر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 184,
        "name": "متر لیزری",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / متر لیزری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 185,
        "name": "تراز دیجیتالی",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / تراز دیجیتالی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 186,
        "name": "کولیس دیجیتال",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / کولیس دیجیتال",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 187,
        "name": "میکرومتر",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / میکرومتر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 188,
        "name": "مولتی متر",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / مولتی متر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 189,
        "name": "دوربین نقشه برداری",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / دوربین نقشه برداری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 190,
        "name": "ترمومتر",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / ترمومتر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 191,
        "name": "ضخامت سنج",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / ضخامت سنج",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 192,
        "name": "رطوبت سنج",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / رطوبت سنج",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 193,
        "name": "سرعت سنج باد",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / سرعت سنج باد",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 194,
        "name": "دیتالاگر دما",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / دیتالاگر دما",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 195,
        "name": "فشارسنج دیجیتال",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / فشارسنج دیجیتال",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 196,
        "name": "ساعت اندیکاتور",
        "description": "",
        "label": "ابزارآلات اندازه گیری و سنجش / ساعت اندیکاتور",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 198,
        "name": "دستگاه CNC",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه CNC",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 199,
        "name": "اره فلکه ای",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / اره فلکه ای",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 200,
        "name": "دستگاه جوش",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه جوش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 201,
        "name": "سنگ فرز",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / سنگ فرز",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 202,
        "name": "دستگاه تراش",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه تراش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 203,
        "name": "گیره نجاری",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / گیره نجاری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 204,
        "name": "دستگاه مکنده صنعتی",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه مکنده صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 205,
        "name": "دستگاه فرز نجاری",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه فرز نجاری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 206,
        "name": "کمپرسور باد صنعتی",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / کمپرسور باد صنعتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 207,
        "name": "اسپری رنگ",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / اسپری رنگ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 208,
        "name": "دستگاه پولیش",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / دستگاه پولیش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 209,
        "name": "سوهان",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / سوهان",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 210,
        "name": "پیستوله رنگ",
        "description": "",
        "label": "ابزار و تجهیزات کارگاهی / پیستوله رنگ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 212,
        "name": "لوله بر",
        "description": "",
        "label": "ابزارآلات تاسیساتی / لوله بر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 213,
        "name": "دستگاه جوش لوله",
        "description": "",
        "label": "ابزارآلات تاسیساتی / دستگاه جوش لوله",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 214,
        "name": "تفنگ میخکوب",
        "description": "",
        "label": "ابزارآلات تاسیساتی / تفنگ میخکوب",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 215,
        "name": "لوله خم کن",
        "description": "",
        "label": "ابزارآلات تاسیساتی / لوله خم کن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 216,
        "name": "فنر لوله بازکن",
        "description": "",
        "label": "ابزارآلات تاسیساتی / فنر لوله بازکن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 217,
        "name": "فشارسنج لوله",
        "description": "",
        "label": "ابزارآلات تاسیساتی / فشارسنج لوله",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 218,
        "name": "آچار لوله گیر",
        "description": "",
        "label": "ابزارآلات تاسیساتی / آچار لوله گیر",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 219,
        "name": "دریل ستونی",
        "description": "",
        "label": "ابزارآلات تاسیساتی / دریل ستونی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 220,
        "name": "دستگاه تست نشتی گاز",
        "description": "",
        "label": "ابزارآلات تاسیساتی / دستگاه تست نشتی گاز",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 221,
        "name": "دستگاه برش لوله",
        "description": "",
        "label": "ابزارآلات تاسیساتی / دستگاه برش لوله",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 222,
        "name": "عایق بندی حرارتی",
        "description": "",
        "label": "ابزارآلات تاسیساتی / عایق بندی حرارتی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 224,
        "name": "کلاه ایمنی ",
        "description": "",
        "label": "تجهیزات ایمنی / کلاه ایمنی ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 225,
        "name": "کفش ایمنی",
        "description": "",
        "label": "تجهیزات ایمنی / کفش ایمنی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 226,
        "name": "عینک محافظ",
        "description": "",
        "label": "تجهیزات ایمنی / عینک محافظ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 227,
        "name": "شیلد صورت",
        "description": "",
        "label": "تجهیزات ایمنی / شیلد صورت",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 228,
        "name": "گوش گیر الکترونیکی",
        "description": "",
        "label": "تجهیزات ایمنی / گوش گیر الکترونیکی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 229,
        "name": "دستکش ایمنی",
        "description": "",
        "label": "تجهیزات ایمنی / دستکش ایمنی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 230,
        "name": "لباس ایمنی",
        "description": "",
        "label": "تجهیزات ایمنی / لباس ایمنی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 231,
        "name": "کپسول آتش نشانی",
        "description": "",
        "label": "تجهیزات ایمنی / کپسول آتش نشانی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 233,
        "name": "بیل، کلنگ، شن کش، داس",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / بیل، کلنگ، شن کش، داس",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 234,
        "name": "قیچی و اره باغبانی",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / قیچی و اره باغبانی",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 235,
        "name": "چمن زن ",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / چمن زن ",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 236,
        "name": "سمپاش",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / سمپاش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 237,
        "name": "نهرکن",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / نهرکن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 238,
        "name": "دستگاه علف تراش",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / دستگاه علف تراش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 239,
        "name": "نازل آبیاری",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / نازل آبیاری",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 240,
        "name": "موتور پمپ آب",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / موتور پمپ آب",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 241,
        "name": "بذرپاش",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / بذرپاش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 242,
        "name": "کودپاش",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / کودپاش",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 243,
        "name": "دستگاه وجین کن",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / دستگاه وجین کن",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 244,
        "name": "تراکتور کوچک",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / تراکتور کوچک",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 245,
        "name": "فرغون",
        "description": "",
        "label": "ابزارآلات باغبانی و کشاورزی / فرغون",
        "productCategoryId": 3,
        "productCategoryName": "ابزارآلات"
    },
    {
        "value": 247,
        "name": "رقص نور",
        "description": "",
        "label": "تجهیزات  نورپردازی / رقص نور",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 248,
        "name": "مه ساز",
        "description": "",
        "label": "تجهیزات  نورپردازی / مه ساز",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 249,
        "name": "استروب",
        "description": "",
        "label": "تجهیزات  نورپردازی / استروب",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 250,
        "name": "لیزرشو",
        "description": "",
        "label": "تجهیزات  نورپردازی / لیزرشو",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 251,
        "name": "افکت های نورپردازی",
        "description": "",
        "label": "تجهیزات  نورپردازی / افکت های نورپردازی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 253,
        "name": "ظروف کرایه ای",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / ظروف کرایه ای",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 254,
        "name": "میز و صندلی ",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / میز و صندلی ",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 255,
        "name": "ترموس چای و قهوه",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / ترموس چای و قهوه",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 256,
        "name": "سماور",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / سماور",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 257,
        "name": "میز بار",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / میز بار",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 258,
        "name": "سینی پذیرایی",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / سینی پذیرایی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 259,
        "name": "دستگاه یخ ساز",
        "description": "",
        "label": "تجهیزات پذیرایی و سرو غذا / دستگاه یخ ساز",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 261,
        "name": "استند گل ",
        "description": "",
        "label": "لوازم دکور و تزئینات / استند گل ",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 262,
        "name": "فرش و موکت",
        "description": "",
        "label": "لوازم دکور و تزئینات / فرش و موکت",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 263,
        "name": "بنر و استند تبلیغاتی",
        "description": "",
        "label": "لوازم دکور و تزئینات / بنر و استند تبلیغاتی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 264,
        "name": "میز کادو",
        "description": "",
        "label": "لوازم دکور و تزئینات / میز کادو",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 265,
        "name": "پرده پس زمینه",
        "description": "",
        "label": "لوازم دکور و تزئینات / پرده پس زمینه",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 266,
        "name": "قاب عکس تشریفاتی",
        "description": "",
        "label": "لوازم دکور و تزئینات / قاب عکس تشریفاتی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 268,
        "name": "استیج",
        "description": "",
        "label": "سازه های مراسم و نمایشگاه ها / استیج",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 269,
        "name": "سکو",
        "description": "",
        "label": "سازه های مراسم و نمایشگاه ها / سکو",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 270,
        "name": "چادر و سایه بان مراسم",
        "description": "",
        "label": "سازه های مراسم و نمایشگاه ها / چادر و سایه بان مراسم",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 271,
        "name": "داربست نمایشگاهی",
        "description": "",
        "label": "سازه های مراسم و نمایشگاه ها / داربست نمایشگاهی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 272,
        "name": "بنر و بک دراپ تبلیغاتی",
        "description": "",
        "label": "سازه های مراسم و نمایشگاه ها / بنر و بک دراپ تبلیغاتی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 274,
        "name": "دستگاه مه سرد",
        "description": "",
        "label": "لوازم آتش بازی و نمایش ویژه / دستگاه مه سرد",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 275,
        "name": "کاغذپاش",
        "description": "",
        "label": "لوازم آتش بازی و نمایش ویژه / کاغذپاش",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 276,
        "name": "گاز هلیوم برای بادکنک",
        "description": "",
        "label": "لوازم آتش بازی و نمایش ویژه / گاز هلیوم برای بادکنک",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 278,
        "name": "بلیت خوان ",
        "description": "",
        "label": "سیستم های مدیریت رویداد و ثبت نام / بلیت خوان ",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 279,
        "name": "دستگاه نوبت دهی",
        "description": "",
        "label": "سیستم های مدیریت رویداد و ثبت نام / دستگاه نوبت دهی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 280,
        "name": "نرم افزار مدیریت مهمانان",
        "description": "",
        "label": "سیستم های مدیریت رویداد و ثبت نام / نرم افزار مدیریت مهمانان",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 281,
        "name": "QR کدخوان",
        "description": "",
        "label": "سیستم های مدیریت رویداد و ثبت نام / QR کدخوان",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 283,
        "name": "بخاری فضای باز",
        "description": "",
        "label": "تجهیزات گرمایشی و سرمایشی / بخاری فضای باز",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 284,
        "name": "هیتر گازی",
        "description": "",
        "label": "تجهیزات گرمایشی و سرمایشی / هیتر گازی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 285,
        "name": "کولر پرتابل",
        "description": "",
        "label": "تجهیزات گرمایشی و سرمایشی / کولر پرتابل",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 286,
        "name": "پنکه صنعتی",
        "description": "",
        "label": "تجهیزات گرمایشی و سرمایشی / پنکه صنعتی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 287,
        "name": "بخارساز فضاهای باز",
        "description": "",
        "label": "تجهیزات گرمایشی و سرمایشی / بخارساز فضاهای باز",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 289,
        "name": "ویدئو پروژکتور",
        "description": "",
        "label": "تجهیزات برگزاری کنفرانس و سمینار / ویدئو پروژکتور",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 290,
        "name": "پرده نمایش",
        "description": "",
        "label": "تجهیزات برگزاری کنفرانس و سمینار / پرده نمایش",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 291,
        "name": "تریبون سخنرانی",
        "description": "",
        "label": "تجهیزات برگزاری کنفرانس و سمینار / تریبون سخنرانی",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 292,
        "name": "سیستم ترجمه همزمان",
        "description": "",
        "label": "تجهیزات برگزاری کنفرانس و سمینار / سیستم ترجمه همزمان",
        "productCategoryId": 4,
        "productCategoryName": "مراسم و رویدادها"
    },
    {
        "value": 293,
        "name": "کتاب‌های تخصصی",
        "description": "",
        "label": "فرهنگی، هنری و آموزشی / کتاب‌های تخصصی",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 294,
        "name": "کتاب‌های ادبی، داستان، رمان و شعر",
        "description": "",
        "label": "فرهنگی، هنری و آموزشی / کتاب‌های ادبی، داستان، رمان و شعر",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 295,
        "name": "کتاب‌های کمک درسی",
        "description": "",
        "label": "فرهنگی، هنری و آموزشی / کتاب‌های کمک درسی",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 296,
        "name": "ماکت‌ها و مدل‌های آموزشی",
        "description": "",
        "label": "فرهنگی، هنری و آموزشی / ماکت‌ها و مدل‌های آموزشی",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 298,
        "name": "گیتار",
        "description": "",
        "label": "لوازم موسیقی و سازها / گیتار",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 299,
        "name": "ویولن",
        "description": "",
        "label": "لوازم موسیقی و سازها / ویولن",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 300,
        "name": "پیانو",
        "description": "",
        "label": "لوازم موسیقی و سازها / پیانو",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 301,
        "name": "کیبورد",
        "description": "",
        "label": "لوازم موسیقی و سازها / کیبورد",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 302,
        "name": "سنتور",
        "description": "",
        "label": "لوازم موسیقی و سازها / سنتور",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 303,
        "name": "دف",
        "description": "",
        "label": "لوازم موسیقی و سازها / دف",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 304,
        "name": "تار",
        "description": "",
        "label": "لوازم موسیقی و سازها / تار",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 305,
        "name": "سه تار",
        "description": "",
        "label": "لوازم موسیقی و سازها / سه تار",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 306,
        "name": "تنبک",
        "description": "",
        "label": "لوازم موسیقی و سازها / تنبک",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 307,
        "name": "کاخن",
        "description": "",
        "label": "لوازم موسیقی و سازها / کاخن",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 308,
        "name": "سازدهنی ",
        "description": "",
        "label": "لوازم موسیقی و سازها / سازدهنی ",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 309,
        "name": "مترونوم",
        "description": "",
        "label": "لوازم موسیقی و سازها / مترونوم",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 310,
        "name": "تیونر",
        "description": "",
        "label": "لوازم موسیقی و سازها / تیونر",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 311,
        "name": "مضراب ",
        "description": "",
        "label": "لوازم موسیقی و سازها / مضراب ",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 312,
        "name": "استند نت ",
        "description": "",
        "label": "لوازم موسیقی و سازها / استند نت ",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 314,
        "name": "ابزار چرم دوزی ",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / ابزار چرم دوزی ",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 315,
        "name": "دستگاه گلدوزی",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / دستگاه گلدوزی",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 316,
        "name": "ابزار سفال گری ",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / ابزار سفال گری ",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 317,
        "name": "وسایل معرق کاری",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / وسایل معرق کاری",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 318,
        "name": "خطاطی و خوشنویسی",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / خطاطی و خوشنویسی",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 319,
        "name": "ابزار حکاکی روی چوب و فلز",
        "description": "",
        "label": "لوازم صنایع دستی و هنرهای سنتی  / ابزار حکاکی روی چوب و فلز",
        "productCategoryId": 5,
        "productCategoryName": "فرهنگی، هنری و آموزشی"
    },
    {
        "value": 321,
        "name": "لباس های مجلسی زنانه",
        "description": "",
        "label": "مد و پوشاک / لباس های مجلسی زنانه",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 322,
        "name": "لباس عروس",
        "description": "",
        "label": "مد و پوشاک / لباس عروس",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 323,
        "name": "کت و شلوار مجلسی",
        "description": "",
        "label": "مد و پوشاک / کت و شلوار مجلسی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 324,
        "name": "لباس های سنتی",
        "description": "",
        "label": "مد و پوشاک / لباس های سنتی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 325,
        "name": "لباس نمایش و تئاتر",
        "description": "",
        "label": "مد و پوشاک / لباس نمایش و تئاتر",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 326,
        "name": "جواهرات و زیورآلات لوکس",
        "description": "",
        "label": "مد و پوشاک / جواهرات و زیورآلات لوکس",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 327,
        "name": "ساعت های لوکس",
        "description": "",
        "label": "مد و پوشاک / ساعت های لوکس",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 328,
        "name": "عینک آفتابی برند",
        "description": "",
        "label": "مد و پوشاک / عینک آفتابی برند",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 329,
        "name": "لباس های فصلی خاص",
        "description": "",
        "label": "مد و پوشاک / لباس های فصلی خاص",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 330,
        "name": "لباس های تم دار و خاص",
        "description": "",
        "label": "مد و پوشاک / لباس های تم دار و خاص",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 331,
        "name": "اکسسوری ها و لوازم جانبی",
        "description": "",
        "label": "مد و پوشاک / اکسسوری ها و لوازم جانبی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 333,
        "name": "کالسکه",
        "description": "",
        "label": "کودکان و نوزادان / کالسکه",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 334,
        "name": "کریر",
        "description": "",
        "label": "کودکان و نوزادان / کریر",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 335,
        "name": "صندلی ماشین کودک",
        "description": "",
        "label": "کودکان و نوزادان / صندلی ماشین کودک",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 336,
        "name": "تاب و سرسره",
        "description": "",
        "label": "کودکان و نوزادان / تاب و سرسره",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 337,
        "name": "تخت و گهواره",
        "description": "",
        "label": "کودکان و نوزادان / تخت و گهواره",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 338,
        "name": "واکر کودک",
        "description": "",
        "label": "کودکان و نوزادان / واکر کودک",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 339,
        "name": "لباس های مناسب جشن و عکاسی کودک",
        "description": "",
        "label": "کودکان و نوزادان / لباس های مناسب جشن و عکاسی کودک",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 340,
        "name": "لباس شخصیت های کارتونی",
        "description": "",
        "label": "کودکان و نوزادان / لباس شخصیت های کارتونی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 341,
        "name": "پمپ شیر برقی",
        "description": "",
        "label": "کودکان و نوزادان / پمپ شیر برقی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 343,
        "name": "سشوار حرفه ای",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / سشوار حرفه ای",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 344,
        "name": "اتو مو ",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / اتو مو ",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 345,
        "name": "بابلیس",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / بابلیس",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 346,
        "name": "دستگاه فر مو",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه فر مو",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 347,
        "name": "دستگاه کراتینه و پروتئین تراپی",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه کراتینه و پروتئین تراپی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 348,
        "name": "دستگاه اکستنشن مو",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه اکستنشن مو",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 349,
        "name": "دستگاه رنگ و مش",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه رنگ و مش",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 350,
        "name": "دستگاه هیدروژن تراپی",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه هیدروژن تراپی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 351,
        "name": "چراغ و آینه مخصوص میکاپ",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / چراغ و آینه مخصوص میکاپ",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 352,
        "name": "دستگاه گریم و ایربراش",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه گریم و ایربراش",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 353,
        "name": "کیت کانتورینگ و گریم حرفه ای",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / کیت کانتورینگ و گریم حرفه ای",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 354,
        "name": "دستگاه UV/LED لاک ژل",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه UV/LED لاک ژل",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 355,
        "name": "سوهان برقی ناخن",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / سوهان برقی ناخن",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 356,
        "name": "میز و صندلی مخصوص ناخن کار",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / میز و صندلی مخصوص ناخن کار",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 357,
        "name": "ابزار کاشت ناخن",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / ابزار کاشت ناخن",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 358,
        "name": "کاتالوگ طرح های ناخن",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / کاتالوگ طرح های ناخن",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 359,
        "name": "دستگاه پارافین تراپی",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه پارافین تراپی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 360,
        "name": "دستگاه وکس (ذوب کننده موم)",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه وکس (ذوب کننده موم)",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 361,
        "name": "تخت اپیلاسیون",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / تخت اپیلاسیون",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 362,
        "name": "پارچه وکس",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / پارچه وکس",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 363,
        "name": "هیتر و گرم کن موم",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / هیتر و گرم کن موم",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 364,
        "name": "دستگاه لیزر خانگی و سالنی",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه لیزر خانگی و سالنی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 365,
        "name": "دستگاه بخور صورت",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه بخور صورت",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 366,
        "name": "دستگاه هیدرودرم و میکرودرم",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه هیدرودرم و میکرودرم",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 367,
        "name": "دستگاه لیفتینگ و RF",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه لیفتینگ و RF",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 368,
        "name": "تخت ماساژ",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / تخت ماساژ",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 369,
        "name": "دستگاه میکروپیگمنتیشن",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / دستگاه میکروپیگمنتیشن",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 370,
        "name": "میز و صندلی مخصوص تتوکار",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / میز و صندلی مخصوص تتوکار",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 371,
        "name": "صندلی و آینه آرایشگاهی",
        "description": "",
        "label": "زیبایی و تجهیزات آرایشگری / صندلی و آینه آرایشگاهی",
        "productCategoryId": 6,
        "productCategoryName": "مد، پوشاک و زیبایی"
    },
    {
        "value": 373,
        "name": "ویلچر",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / ویلچر",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 374,
        "name": "واکر",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / واکر",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 375,
        "name": "عصا",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / عصا",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 376,
        "name": "تخت بیمارستانی",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / تخت بیمارستانی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 377,
        "name": "تشک مواج",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / تشک مواج",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 378,
        "name": "بالابر بیمار",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / بالابر بیمار",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 379,
        "name": "دستگاه اکسیژن ساز",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / دستگاه اکسیژن ساز",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 380,
        "name": "کپسول اکسیژن",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / کپسول اکسیژن",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 381,
        "name": "دستگاه کمک تنفسی (CPAP و BiPAP)",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / دستگاه کمک تنفسی (CPAP و BiPAP)",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 382,
        "name": "مانیتور علائم حیاتی",
        "description": "",
        "label": "تجهیزات مراقبت از بیمار / مانیتور علائم حیاتی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 384,
        "name": "دستگاه زردی نوزاد ( فتوتراپی )",
        "description": "",
        "label": "تجهیزات مراقبت از مادر و نوزاد / دستگاه زردی نوزاد ( فتوتراپی )",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 385,
        "name": "دستگاه شیردوش برقی حرفه ای",
        "description": "",
        "label": "تجهیزات مراقبت از مادر و نوزاد / دستگاه شیردوش برقی حرفه ای",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 386,
        "name": "دستگاه گرم کن شیشه شیر",
        "description": "",
        "label": "تجهیزات مراقبت از مادر و نوزاد / دستگاه گرم کن شیشه شیر",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 387,
        "name": "دستگاه بیلی روبین متر",
        "description": "",
        "label": "تجهیزات مراقبت از مادر و نوزاد / دستگاه بیلی روبین متر",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 389,
        "name": "دستگاه فیزیوتراپی خانگی",
        "description": "",
        "label": "تجهیزات فیزیوتراپی و توان بخشی / دستگاه فیزیوتراپی خانگی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 390,
        "name": "دستگاه الکتروتراپی (TENS)",
        "description": "",
        "label": "تجهیزات فیزیوتراپی و توان بخشی / دستگاه الکتروتراپی (TENS)",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 391,
        "name": "دستگاه ماساژور حرفه ای",
        "description": "",
        "label": "تجهیزات فیزیوتراپی و توان بخشی / دستگاه ماساژور حرفه ای",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 392,
        "name": "وسایل توان بخشی حرکتی",
        "description": "",
        "label": "تجهیزات فیزیوتراپی و توان بخشی / وسایل توان بخشی حرکتی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 393,
        "name": "تردمیل مخصوص فیزیوتراپی",
        "description": "",
        "label": "تجهیزات فیزیوتراپی و توان بخشی / تردمیل مخصوص فیزیوتراپی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 395,
        "name": "دستگاه نوار قلب (ECG)",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / دستگاه نوار قلب (ECG)",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 396,
        "name": "دستگاه سونوگرافی پرتابل",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / دستگاه سونوگرافی پرتابل",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 397,
        "name": "فشارسنج دیجیتال ",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / فشارسنج دیجیتال ",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 398,
        "name": "دستگاه تست قند خون ",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / دستگاه تست قند خون ",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 399,
        "name": "چراغ معاینه پزشکی",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / چراغ معاینه پزشکی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 400,
        "name": "اتوسکوپ و افتالموسکوپ  ",
        "description": "",
        "label": "تجهیزات پزشکی تخصصی / اتوسکوپ و افتالموسکوپ  ",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 402,
        "name": "میکروسکوپ",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / میکروسکوپ",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 403,
        "name": "سانتریفیوژ",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / سانتریفیوژ",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 404,
        "name": "هموگلوبین سنج",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / هموگلوبین سنج",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 405,
        "name": "تب سنج لیزری پزشکی",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / تب سنج لیزری پزشکی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 406,
        "name": "اسپیرومتر",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / اسپیرومتر",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 407,
        "name": "تست های تشخیصی پرتابل",
        "description": "",
        "label": "تجهیزات آزمایشگاهی و تشخیصی / تست های تشخیصی پرتابل",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 409,
        "name": "دستگاه لیزر پوست",
        "description": "",
        "label": "تجهیزات پزشکی زیبایی و پوست / دستگاه لیزر پوست",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 410,
        "name": "دستگاه میکرودرم ابریژن",
        "description": "",
        "label": "تجهیزات پزشکی زیبایی و پوست / دستگاه میکرودرم ابریژن",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 411,
        "name": "دستگاه RF و هایفو",
        "description": "",
        "label": "تجهیزات پزشکی زیبایی و پوست / دستگاه RF و هایفو",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 412,
        "name": "دستگاه مزوتراپی",
        "description": "",
        "label": "تجهیزات پزشکی زیبایی و پوست / دستگاه مزوتراپی",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 413,
        "name": "دستگاه لیفتینگ صورت",
        "description": "",
        "label": "تجهیزات پزشکی زیبایی و پوست / دستگاه لیفتینگ صورت",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 415,
        "name": "برانکارد",
        "description": "",
        "label": "تجهیزات اورژانسی و امداد و نجات / برانکارد",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 416,
        "name": "جعبه کمک های اولیه حرفه ای",
        "description": "",
        "label": "تجهیزات اورژانسی و امداد و نجات / جعبه کمک های اولیه حرفه ای",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 417,
        "name": "دفیبریلاتور (AED)",
        "description": "",
        "label": "تجهیزات اورژانسی و امداد و نجات / دفیبریلاتور (AED)",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 418,
        "name": "تجهیزات احیا و CPR",
        "description": "",
        "label": "تجهیزات اورژانسی و امداد و نجات / تجهیزات احیا و CPR",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 419,
        "name": "کپسول اکسیژن همراه",
        "description": "",
        "label": "تجهیزات اورژانسی و امداد و نجات / کپسول اکسیژن همراه",
        "productCategoryId": 7,
        "productCategoryName": "سلامت و پزشکی"
    },
    {
        "value": 420,
        "name": "لیفتراک ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / لیفتراک ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 421,
        "name": "جرثقیل متحرک ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / جرثقیل متحرک ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 422,
        "name": "دامپر و مینی دامپر ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / دامپر و مینی دامپر ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 423,
        "name": "لودر و مینی لودر ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / لودر و مینی لودر ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 424,
        "name": "بولدوزر ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / بولدوزر ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 425,
        "name": "گریدر ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / گریدر ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 426,
        "name": "تانکر آب رسان و سوخت رسان",
        "description": null,
        "label": "وسایل نقلیه صنعتی / تانکر آب رسان و سوخت رسان",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 427,
        "name": "تراکتور ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / تراکتور ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 428,
        "name": "کمباین ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / کمباین ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 429,
        "name": "تریلر کشاورزی ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / تریلر کشاورزی ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 430,
        "name": "سمپاش خودکششی ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / سمپاش خودکششی ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 431,
        "name": "ماشین نشاکار و بذرکار ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / ماشین نشاکار و بذرکار ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 432,
        "name": "شیردوش سیار ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / شیردوش سیار ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 433,
        "name": "چوب بر جنگلی ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / چوب بر جنگلی ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    },
    {
        "value": 434,
        "name": "ماشین آلات مخصوص باغداری ",
        "description": null,
        "label": "وسایل نقلیه صنعتی / ماشین آلات مخصوص باغداری ",
        "productCategoryId": 8,
        "productCategoryName": "وسایل نقلیه صنعتی"
    }
]
export default subCategoryList;
